<div class="tab pointer" *ngFor="let tab of tabs" [class.active]="tab.label === activeTab" (click)="setActiveTab(tab.label)">
    {{ tab.label }}
    <div class="badge" *ngIf="tab?.badge>0">{{tab?.badge}}</div>
</div>